import { default as module } from './AbstractModule';
import { getData } from '../utils/html'
import { shuffle } from '../utils/array'

export default class extends module {
    constructor(m) {
        super(m);

        this.inner = this.$('inner')
        this.sentences = this.getData('sentences').split(',')
        this.sentence = this.$('sentence')
        this.video = this.$('video')
    }

    show(e) {
        this.el.classList.add('is-active')
        this.removeReference()
        this.setReference(e.target)

        // SIZE VIDEO
        const viewportW = window.innerWidth
        const viewportH = window.innerHeight
        const screenRatio = viewportW / viewportH
        const videoRatio = this.video.videoWidth / this.video.videoHeight
        let top,left,height,width;
        if(screenRatio < videoRatio) {
            top = '0px';
            height = '100%';
            width = 'auto';
            const realW = viewportH * videoRatio;
            left = (-(realW - viewportW)/2)+'px'
        } else {
            left = '0px';
            height = 'auto';
            width = '100%';
            const realH = viewportW * (1/videoRatio)
            top = (-(realH - viewportH)/2)+'px'
        }
        TweenMax.set(this.video, { top, left, width, height })

        this.video.play()

        if(!this.active) {
            this.active = true
            this.update()
        }

        clearTimeout(this.hideTimeout)

        this.loopSentences()
    }

    hide() {
        this.el.classList.remove('is-active')

        this.stopLoopSentences()

        this.hideTimeout = setTimeout(() => {
            this.removeReference()
            cancelAnimationFrame(this.raf)
            this.active = false
            this.video.pause()
        }, 500);
    }

    loopSentences() {
        this.sentences = shuffle(this.sentences)

        let i = 0
        this.loopInterval = setInterval(() => {
            this.sentence.innerText = this.sentences[i % this.sentences.length]
            i++
        }, 1000)
    }

    stopLoopSentences() {
        clearInterval(this.loopInterval)
        this.sentence.innerText = ''
    }

    setReference(element) {
        this.reference = element
        this.clone = this.reference.cloneNode(true)
        this.style = window.getComputedStyle(this.reference, null)

        this.clone.classList.remove('-highlight')
        this.clone.classList.remove('-show-inview')
        this.clone.classList.remove('is-show')

        TweenMax.set(this.clone, {
            position: 'absolute', top: 0, left: 0,
            fontFamily: this.style.getPropertyValue('font-family'),
            fontSize: this.style.getPropertyValue('font-size'),
            lineHeight: this.style.getPropertyValue('line-height'),
            fontWeight: this.style.getPropertyValue('font-weight'),
            color: '#fff'
        })

        this.inner.appendChild(this.clone)
    }

    removeReference() {
        this.reference = null
        if(this.clone && this.clone.parentNode)
            this.clone.parentNode.removeChild(this.clone)
        this.clone = null
    }

    update() {
        this.referenceBCR = this.reference.getBoundingClientRect()
        TweenMax.set(this.clone, { x: this.referenceBCR.left, y: this.referenceBCR.top })

        if(this.active)
            this.raf = requestAnimationFrame(this.update.bind(this))
    }

    destroy() {
        this.stopLoopSentences()
        this.removeReference()
        cancelAnimationFrame(this.raf)
    }
}
